export const css = {
    root: '_32FMVlPh',
    wrapper: 'UjhIf0-a',
    input: '_3w7igrDp',
    labelWrapper: '_2GfTmWWw',
    notchedOutline: '_35xkZPCN',
    focused: '_2dbPFshb',
    leading: '_3G3nBaW-',
    trailing: '_1L2gLdEX',
    disabled: '_3g9IyfhA',
    readonly: 'D8rTeuAE',
    invalid: '_2kJsD0G6',
    valid: 'YQsgJ_kX',
    hasLeading: '_3YenmuIH',
    hasTrailing: '_1Ygea3kO',
    defaultKind: 'fAEX7kLY',
    outlinedKind: 'fx-RR6yF',
    notchedOutlineNotch: '_2lzT7FCO',
    ' _key': 'apic-theme/dojo/text-input'
};
export default css;
